import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import DynamicGigListings from './DynamicGigListings';
import { GIG_CARDS_LAZY_OFFSET, LIST_VIEW_CARDS_LAZY_OFFSET } from './constants';
import InlineSvgProText from './inlineSvgProText';
import './index.scss';

const ProFirstGigListings = ({ listings }) => {
    const { showListViewCards, gigs, proData } = listings;
    const { query, page, proGigs, subCategoryName, nestedSubCategoryName } = proData;
    const showProListings = page.toString() === (1).toString();

    const proGigCount = proGigs.length;

    const hasProGigs = proGigs.length > 0,
        hasNormalGigs = gigs.length > 0;

    const baseLazyOffset = showListViewCards ? LIST_VIEW_CARDS_LAZY_OFFSET : GIG_CARDS_LAZY_OFFSET,
        proLazyOffset = Math.min(proGigCount, baseLazyOffset),
        gigLazyOffset = baseLazyOffset - proLazyOffset;

    return (
        <React.Fragment>
            {hasProGigs ?
                <div className="listings-wrapper">
                    <ProGigsListingsTitle query={query} subCategoryName={subCategoryName} nestedSubCategoryName={nestedSubCategoryName}/>
                    <DynamicGigListings listings={{ ...listings, gigs: proGigs }} gigCardLazyLoadOffset={proLazyOffset} listViewLazyLoadOffset={proLazyOffset}/>

                    {hasNormalGigs && <React.Fragment>
                        <GigsListingsTitle query={query} className={'top-padding'}/>
                        <DynamicGigListings listings={listings} gigCardLazyLoadOffset={gigLazyOffset} listViewLazyLoadOffset={gigLazyOffset}/>
                    </React.Fragment>}
                </div>
                :
                <div className="listings-wrapper">
                    {showProListings && <div>
                        <ProGigsListingsTitle query={query} subCategoryName={subCategoryName} nestedSubCategoryName={nestedSubCategoryName}/>
                        <span className="no-pro-results">
                            <I18n k={`search_perseus.pro_first.${query ? 'no_pro_results_query' : 'no_pro_results_category'}`}/>
                        </span>
                    </div>}

                    <GigsListingsTitle query={query} className={showProListings ? 'top-padding' : ''}/>
                    <DynamicGigListings listings={listings} gigCardLazyLoadOffset={gigLazyOffset} listViewLazyLoadOffset={gigLazyOffset}/>
                </div>
            }
        </React.Fragment>
    );
};

const ProGigsListingsTitle = ({ query, className = '', subCategoryName, nestedSubCategoryName = '' }) => (
    <h2 className={classNames('listings-title', `${className}`)}>
        <InlineSvgProText/>&nbsp;
        {
            query ?
                <I18n k="search_perseus.pro_first.pro_listings_query" params={{ query }}/>
                : <I18n k="search_perseus.pro_first.pro_listings_category" params={{ name: nestedSubCategoryName || subCategoryName }}/>
        }
    </h2>
);

const GigsListingsTitle = ({ query, className = '' }) => (
    <h2 className={classNames('listings-title', `${className}`)}>{query ? <I18n k="search_perseus.pro_first.gig_listings_query" params={{ query }}/> : <I18n k="search_perseus.pro_first.gig_listings"/>}</h2>
);

export default ProFirstGigListings;
